export const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
